import React from "react";
import PropTypes from "prop-types";
import { relativeTime } from "../supportConstants";
import styles from "./MessageBubble.module.css";

/**
 * Bolha individual da thread, estilo conversa de mensagens.
 *
 * - Cliente (`isStaff === false`): alinhado à DIREITA, fundo Nexus Blue,
 *   texto branco, label "Você".
 * - Equipe Nexus (`isStaff === true`): alinhado à ESQUERDA, fundo cinza claro,
 *   label "Suporte Nexus" em negrito + ícone.
 *
 * `isDescription` estiliza a primeira bolha (campo `description` do ticket)
 * levemente diferente, prefixada com "📋 Descrição do chamado".
 *
 * `pending` (atualização otimista) reduz a opacidade até o backend confirmar.
 */
export default function MessageBubble({ content, isStaff, createdAt, isDescription, pending }) {
  const sideClass = isStaff ? styles.staff : styles.client;

  return (
    <div className={`${styles.row} ${sideClass}`}>
      <div
        className={`${styles.bubble} ${isStaff ? styles.bubbleStaff : styles.bubbleClient} ${
          isDescription ? styles.bubbleDescription : ""
        } ${pending ? styles.pending : ""}`}
      >
        {isDescription && (
          <span className={styles.descLabel}>📋 Descrição do chamado</span>
        )}
        <p className={styles.content}>{content}</p>
      </div>
      <span className={styles.meta}>
        {isStaff ? (
          <>
            <span aria-hidden="true">🎧</span>{" "}
            <strong>Suporte Nexus</strong>
          </>
        ) : (
          <strong>Você</strong>
        )}
        {createdAt && <span className={styles.time}> · {pending ? "enviando…" : relativeTime(createdAt)}</span>}
      </span>
    </div>
  );
}

MessageBubble.propTypes = {
  content: PropTypes.string.isRequired,
  isStaff: PropTypes.bool,
  createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  isDescription: PropTypes.bool,
  pending: PropTypes.bool,
};
